/* eslint-disable camelcase */
export const video_interview = {
  'micro-test': 'Проверка микрофона',
  'indicator-reacts': 'Круговой индикатор реагирует на внешние звуки. Заполни его полностью',
  'if-indicator-donot-reacts': `Если индикатор не реагирует,
    либо браузер дополнительно запрашивает доступ, нажмите “Разрешить доступ”`,
  'interview-finished': 'Интервью завершено. Спасибо!',
  'answer-successfuly-sent': 'Ответы успешно отправлены',
  'prepering-to-recording': `У тебя есть {seconds} секунд на подготовку.
    Запись начнётся после того, как ты нажмёшь "Начать запись".`,
  'current-step': 'вопрос {currentStep} из {maxStep}',
  'question-text': 'Текст вопроса:',
  'show-question': 'Показать вопрос',
  'test-record': 'Пробная запись',
  'make-test-record': 'Сделай пробную запись: скажи что-нибудь на камеру. Ты увидишь, как будут выглядеть твои ответы',
  'start-recording': 'Начать запись',
  'stop-recording': 'Начать запись',
  're-record': 'Начать запись',
  'turn-on-the-camera': 'Включи камеру!',
  'selection-stages': 'Этапы отбора',
  questionnaire: 'Анкета',
  'video-interview': 'Анкета',
};
